export default __webpack_public_path__ + "0ba005f6d30077a8f570f35b36a45b55.svg";